<template>
	<div>
		<modalconfirm ref="modalconfirmAddAdjustment" @action="proccessAdjustment"/>
		<div class="text-h5">Penyesuaian Stok MB</div>
		<v-card class="mt-3" outlined>
			<v-form ref="formAdjustment" role="form" v-on:submit.prevent="addAdjustment">
				<v-card-text class="pt-2">
					<v-alert v-for="(alert, index) in alertMultiple" v-model="alert.show" :key="index" dismissible type="error" elevation="1">
						{{alert.message}}
					</v-alert>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-row>
								<v-col cols="12" md="9" class="py-0">
									<v-autocomplete prepend-icon="mdi-store" v-model="stockist" :loading="isLoading" :items="listStockist" :search-input.sync="search" :item-text="getItemText" item-value="stockist_network_id" flat hide-details outlined dense label="Masukan Kode atau Nama Pelanggan" return-object :filter="customFilter" hide-no-data>
										<template v-slot:item = {item}>
											{{ item.stockist_code }} ({{ item.stockist_name }})
										</template>
										<template v-slot:selection = {item}>
											{{ item.stockist_code }} ({{ item.stockist_name }})
										</template>
									</v-autocomplete>
								</v-col>
							</v-row>
						</v-col>
						<v-col col="12" md="3">
							<v-autocomplete prepend-icon="mdi-cached" :items="platformOpt" item-value="value" item-text="text" v-model="platform" label="Platform" :rules="[inputrules.required]" class="py-3 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-autocomplete>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" md="3">
							<v-menu v-model="menu" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field outlined dense :value="convertDate(adj_date)" label="Tanggal" prepend-icon="mdi-calendar" readonly @focus="() => responseError.date=''" :error-messages="responseError.date" v-bind="attrs" v-on="on"></v-text-field>
								</template>
								<v-date-picker color="primary" v-model="adj_date" locale="id"></v-date-picker>
							</v-menu>
							<v-menu :close-on-content-click="false" v-model="menu2" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field outlined dense :value="adj_time" label="Jam" prepend-icon="mdi-clock-time-four-outline" readonly v-bind="attrs" v-on="on" hide-details="auto"></v-text-field>
								</template>
								<v-time-picker color="primary" v-model="adj_time"></v-time-picker>
							</v-menu>
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<v-textarea :rules="[inputrules.required]" v-model="adj_note" label="Catatan" rows="3" height="107" @focus="() => responseError.note=''" :error-messages="responseError.note" hide-details="auto" outlined dense no-resize></v-textarea>
						</v-col>
						<v-col cols="12" >
							<v-alert type="error" elevation="1" v-if="responseError.product">
								{{responseError.product}}
							</v-alert>
							<v-simple-table>
								<template v-slot:default>
									<thead class="v-data-table-header">
										<tr>
											<th width="5%" class="text-left">Aksi</th>
											<th width="30%" class="text-left">Nama Produk</th>
											<th width="15%" class="text-left">Kode Produk</th>
											<th width="15%" class="text-left">Tipe Penyesuaian</th>
											<th width="10%" class="text-left">Stok {{ platform == 'store' ? 'Store' : 'POS' }}</th>
											<th width="15%" class="text-left">Jumlah</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(product, index) in productsSelected" :key="product.product_id">
											<td>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on" @click.stop="deletefromAdjustment(index)">
															<v-icon dark>mdi-delete</v-icon>
														</v-btn>
													</template>
													<span>Hapus</span>
												</v-tooltip>
											</td>
											<td>
												<v-autocomplete :items="productsNotSelected" :filter="productFilter" return-object item-text="product_name" v-model="product.data" no-data-text="Tidak ada data yang sesuai" :rules="[productRules]" class="py-3 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-autocomplete>
											</td>
											<td>
												<div class="pt-2">{{ product.data.product_code }}</div>
											</td>
											<td>
												<v-autocomplete :items="type_stock" item-value="code" item-text="text" v-model="product.data.type" no-data-text="Tidak ada data yang sesuai" :rules="[inputrules.required]" class="py-3 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-autocomplete>
											</td>
											<td>
												<div v-if="platform == 'store'" class="pt-2">{{ product.data.stock_store }}</div>
												<div v-else class="pt-2">{{ product.data.stock_pos }}</div>
											</td>
											<td>
												<v-currency-field v-model.lazy="product.data.quantity" :rules="[inputrules.required, inputrules.notnull]" outlined dense hide-details="auto" background-color="white" class="py-3 details-mb-0"></v-currency-field>
											</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="px-4 pb-4">
					<v-btn light depressed color="primary" @click="addProduct">
						<v-icon>mdi-plus-circle</v-icon>
						<div class="pl-2 text-capitalize">Tambah Produk</div>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" depressed class="text-capitalize" type="submit" v-if="productsSelected.length > 0">Proses</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex'
import _ from 'lodash';

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			menu: false,
			menu2: false,
			type_stock: [{text : 'Keluar', code: 'out'}, {text: 'Masuk', code: 'in'}],
			platformOpt: [{text:'Store', value:'store'},{text:'POS', value:'pos'}],
			platform:'store',
			adj_date: '',
			adj_time: '00:00',
			adj_note: '',
			productsSelected: [],
            stockist: '',
			isLoading: false,
			search: null,
			listStockist: [],
			params: [
				{
					value: '1',
					comparison: '=',
					type: 'string',
					field: 'stockist_is_active'
				}
			],
			productRules: value => !!value.product_id || 'Tidak boleh kosong',
            stockistRules: value => !!value.stockist_network_id || 'Tidak boleh kosong'
		}
	},
	computed: {
		...mapState('stockAdjustment', ['listProductMB', 'response', 'responseError', 'alertMultiple']),

		productsNotSelected() {
			if (this.productsSelected.length > 0) {
				const productSelected = this.productsSelected.map((el) => el.data)
				return this.listProductMB.map((el) => {
					if (productSelected.includes(el)) {
						el.disabled = true
					} else {
						el.disabled = false
					}
					return el
				})
			}
			return this.listProductMB
		},
	},
	methods: {
		...mapActions('stockAdjustment', ['createAdjustmentMB','getOptionProductMB', 'getStockist']),
		...mapMutations('stockAdjustment', ['saveResponse']),
		...mapMutations(['setOverlay', 'setSnackbar']),

		getItemText(item){
			return `${item.stockist_code} ${item.stockist_name}`;
		},
		recalculateStock(index, type, qty){
			if(type == 'out'){
				this.productsSelected[index].data.stockAfter = this.productsSelected[index].data.stock_pos - qty
			}
			if(type == 'in'){
				this.productsSelected[index].data.stockAfter = parseInt(this.productsSelected[index].data.stock_pos) +parseInt(qty)
			}
		},
		stockOutMinus(item){
			let stock = 0
			if(this.platform == 'pos'){
				stock = item.stock_pos 
			}
			if(this.platform == 'store'){
				stock = item.stock_store 
			}
			if(item.type == 'out'){
				if(item.quantity > stock){
					return true
				} else {
					return false
				}
			}
		},
		customFilter (item, queryText) {
			const textOne = item.stockist_code.toLowerCase()
			const textTwo = item.stockist_name.toLowerCase()
			const searchText = queryText.toLowerCase()

			return textOne.indexOf(searchText) > -1 ||
			textTwo.indexOf(searchText) > -1
		},
		productFilter(item, queryText){
			const text = item.product_name.toLowerCase()
			const searchText = queryText.toLowerCase()

			return text.indexOf(searchText) > -1
		},
		addProduct() {
			if(this.stockist){
				this.responseError.product = ''
				this.productsSelected.push({
					data: {
						product_id: '',
						product_code: '',
						product_name: '',
						quantity: '0',
						stock: 0,
					},
				})
			} else {
				this.setSnackbar({
					show: true,
					color: 'red darken-2',
					text: `Masukkan kode atau nama pelanggan terlebih dahulu`
				})
			} 
		},
		getProductStock(){
			this.productsSelected = []
			this.getOptionProductMB(this.queryString({limit:100,params:[
				{
					value: this.stockist.stockist_code,
					comparison: '=',
					type: 'string',
					field: 'stockist_code',
				}
			]}))
		},
		deletefromAdjustment(index){
			this.productsSelected.splice(index, 1)
		},
		addAdjustment() {
			if (this.$refs.formAdjustment.validate()) {
				this.$refs.modalconfirmAddAdjustment.setMessage('Apakah Anda yakin akan melakukan penyesuaian stok?')
				this.$refs.modalconfirmAddAdjustment.showConfirm()
			}
		},
		async proccessAdjustment(){
			await this.setOverlay(true)
			await this.$refs.modalconfirmAddAdjustment.hideConfirm()
			let productIsMinus = false;
			let product = await this.productsSelected.map( (el) => {
				if(this.stockOutMinus(el.data)){
					productIsMinus = true
				}

				return {
					product_id: el.data.product_id,
					product_name: el.data.product_name,
					product_code: el.data.product_code,
					quantity: el.data.quantity,
					type: el.data.type
				}
			})
			let params = await {
				stockist: this.stockist.stockist_network_id,
				platform: this.platform,
				product: product,
				date: `${this.adj_date} ${this.adj_time}`,
				note: this.adj_note
			}
			if(productIsMinus){
				this.setSnackbar({
					show: true,
					color: 'red darken-2',
					text: `Pastikan jumlah barang keluar tidak melebihi stok`
				})
			} else {
				await this.createAdjustmentMB(params).then(() => {
					if (this.response.code == 200.) {
						this.getProductStock()
						this.resetForm()
					}
				})
			}
			await this.setOverlay(false)
		},
		resetForm(){
			this.saveResponse('')
			this.$refs.formAdjustment.resetValidation()
			this.adj_date = this.today
			this.adj_note = ''
			this.adj_time = this.getCurrentTime()
			this.productsSelected = []
			// this.getOptionProductMB({limit:100})
			// this.getStockist(this.queryString({limit:100, params:this.params}))
		},
		getCurrentTime() {
			let now = new Date();
			let hour = now.getHours();
			let minute = now.getMinutes();
			return hour + ":" + minute;
		},
	},
	created() {
		this.adj_date = this.today
		this.adj_time = this.getCurrentTime()
		this.$store.dispatch('setPageTitle', `Penyesuaian Stok MB`)
		// this.getOptionProductMB({limit:100})
		// this.getStockist(this.queryString({limit:100, params:this.params}))
	},
	watch: {
		search: {
			handler: _.debounce(function() {
				if (!this.search)
					return
				else if (this.search.length <= 2)
					return
				
				if(this.params.length > 1){
					this.params.splice(1,1);
				}
				if (this.search.substring(0, 2) == 'MB' || this.search.substring(0, 1) == 'M') {
					this.params.push({
						value: this.search,
						comparison: 'like',
						type: 'string',
						field: 'stockist_code'
					})
				} else {
					this.params.push({
						value: this.search,
						comparison: 'like',
						type: 'string',
						field: 'stockist_name'
					})
				}

				this.isLoading = true
				this.getStockist(this.queryString({params:this.params})).then( (val) => {
					this.listStockist = val
				}).catch(() => {
					this.listStockist = []
				}).finally(() => {
					this.isLoading = false
				})
			}, 700),
		},
		stockist(newStockist) {
			if(newStockist !== undefined){
				this.getProductStock()
			}
		},
		platform(newPlatform, oldPlatform) {
			if(newPlatform !== oldPlatform){
				this.getProductStock()
			}
		}
	}
}
</script>